import React from "react";
import './Aboutglovalreach.css';
// import product1 from "../../assets/about/facilities/image1.png";


const Aboutglovalreachours = () => {

    return (
        <>

            {/* design */}
            <div className="about-dasmesh-global-react">
                <h3>ASIA PACIFIC</h3>                
                <div className="row">
                    <div className="col-4">
                        <div className="about-dasmesh-product-text-1">
                            <h5>Main Cropes</h5>
                            <p>Wheat, Maize, Rice, Soyabean Etc</p>
                        </div>
                    </div>
                    <div className="col-4">
                    <div className="about-dasmesh-global-product-img">
                        {/* <img src={product1} alt="aboutglovalreach"/> */}
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="about-dasmesh-product-text-1">
                            <h5>Products Ranges</h5>
                            <p>Track Type Combine Harvesters, Rotavator, Seeders, Laser Land Leveler, Straw Reapers Etc</p>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
};

export default Aboutglovalreachours
